<template>
  <div>
    <draggable
        v-model="allColumns"
        v-bind="dragOptions"
        group="levels"
        @start="isDragging = true"
        @end="isDragging = false"
        style="display:inline"
        @change="emitChanges"
    >
      <b-badge class="mr-1"
               :variant="column.columnType === 'dimension' ? 'primary':'info'"
               size="sm"
               v-for="column in allColumns"
               :key="column.name+column.aggregateFunction"
               :value="column">
        {{ column.columnType === 'dimension' ? `${column.name}` : `${column.name} (${column.aggregateFunction || 'sum'})` }}
      </b-badge>
    </draggable>
  </div>
</template>

<script>
import _ from "lodash";
import draggable from "vuedraggable";

export default {
  name: "BqFilterFields",
  components: {draggable},
  props: {
    value: {
      type: Array,
    },
  },
  mounted() {
    this.allColumns = [...this.value];
  },
  watch: {
    value: {
      deep: true,
      handler() {
        this.allColumns = [...this.value];
      }
    },
  },
  data() {
    return {
      isDragging: false,
      allColumns: [],
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 100,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      };
    },
  },
  methods: {
    emitChanges() {
      this.allColumns = _.orderBy(this.allColumns, 'columnType');
      this.$emit('input', this.allColumns);
    }
  }
}
</script>

<style scoped>
.column-badge {
  border-width: 2px !important;
  cursor: pointer;
  padding-left: 1.8em !important;
  padding-right: 0.5em;
  margin-bottom: 0.2em;
}

.dimension {
  border-color: #007bff !important;
  color: #007bff;
}

.measure {
  accent-color: #17a2b8 !important;
  border-color: #17a2b8 !important;
  color: #17a2b8;
  text-align: right;
}

</style>